import React from 'react'
import { IIconProps } from './types'
import { Svg } from './Misc'

export const MinusIcon = (props: IIconProps): React.ReactElement => (
  <Svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5 12h14" />
  </Svg>
)
